"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundMoney = exports.numberOrZero = exports.isPositive = void 0;
__exportStar(require("./percent"), exports);
const isPositive = (value) => {
    if (value && value > 0) {
        return true;
    }
    return false;
};
exports.isPositive = isPositive;
const numberOrZero = (value) => {
    const num = Number(value);
    if (Number.isFinite(num) && num > 0) {
        return num;
    }
    return 0;
};
exports.numberOrZero = numberOrZero;
const roundMoney = (value) => {
    return Number(Number(value).toFixed(2));
};
exports.roundMoney = roundMoney;
//# sourceMappingURL=index.js.map